module.exports = __webpack_public_path__ + "img/BS23.a55beaac.svg";